import styled from 'styled-components';
import { StreetAddress as Address } from '../license/components/license-content-styles';

export const StreetAddress = styled(Address)`
  margin: 0;
`;

export const TaxReportingViewDiv = styled.div`
  width: 100%;
  min-width: 1000px;
  max-width: 1300px;
  height: 100%;
  min-height: 600px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  justify-self: center;
  gap: 20px;

  /* To match the navigation bar */
  @media only screen and (max-width: 1480px) {
    /* Use padding-left rather than margin-left, because the margins will overlap with the side bar for some reason */
    padding-left: 38px;
  }
`;

export const RSuiteDropdownStyler = styled.div`
  & .rs-btn {
    width: ${(props: { width?: string }) => props.width ?? '350px'};
    text-align: left;
  }

  & .rs-dropdown-menu,
  .rs-dropdown-item {
    width: ${(props: { width?: string }) => props.width ?? '350px'};
    text-align: left;

    div {
      width: fit-content;
    }
  }
`;
